import createReactClass from 'create-react-class';
import $ from 'jquery';

import AnswerPanelTableIsCorrectTr from './AnswerPanelTableIsCorrectTr.js';
import AnswerPanelTableQuestionsTr from './AnswerPanelTableQuestionsTr.js';
import {RATING_REASON_INITIAL_LABEL} from './UserRatingNegativeReasonButton.js';
import {DESIGN} from '../global/libs/CONFIG.js';
import CONFIG from '../global/libs/CONFIG.js';
import newlineToBr from '../global/libs/newlineToBr.js';
import myAjax from '../global/libs/myAjax.js';
import './AnswerPanelTable.css';
import './Common.css';
import PropTypes from 'prop-types';
import setAspectRatioToImg from '../global/libs/setAspectRatioToImg.js';

let AnswerPanelTable = createReactClass({
  // ARGS: result, question, gotoQACandidatePanel, askQuestion
  propTypes: {
    result: PropTypes.object.isRequired,
    question: PropTypes.string.isRequired,
    gotoQACandidatePanel: PropTypes.func.isRequired,
    askQuestion: PropTypes.func.isRequired,
    generateAlert: PropTypes.func.isRequired,
    logId: PropTypes.number.isRequired,
    cgId: PropTypes.string.isRequired
  },

  displayShareButton() {
    var shareURL = document.getElementById('share_URL');
    var displayButton = document.getElementById('display_button');

    // コピーボタンが表示されているときは要素を除去して終了
    if (document.getElementById('copy_url')) {
      for (var i = shareURL.childNodes.length - 1; i > 0; i--) {
        if (shareURL.childNodes[i].id != 'copyUrl') {
          shareURL.removeChild(shareURL.childNodes[i - 1]);
        }
      }
      return;
    }

    var qa_id = this.props.result.id;
    var copyUrl = document.createElement('div');
    copyUrl.setAttribute('id', 'copy_url');
    copyUrl.className = 'sub_function__share_text_buttons';

    var urlText = document.createElement('input');
    var backend_serverurl = '';
    backend_serverurl = window.location.origin;
    urlText.type = 'text';
    urlText.value = backend_serverurl + CONFIG.SHARE_URL + qa_id;
    urlText.disabled = true;
    urlText.setAttribute('id', 'url_text');
    urlText.className = 'sub_function__input';
    copyUrl.appendChild(urlText);

    // コピーボタン
    var template_copy_url_elm = document.createElement('button');
    template_copy_url_elm.className = 'template--copy__button';
    template_copy_url_elm.innerHTML = 'コピー';
    template_copy_url_elm.addEventListener('click', function () {
      if (window.clipboardData) {
        // IEの場合
        window.clipboardData.setData('URL', urlText.value);
        alert('コピーしました。');
      } else if (navigator.clipboard) {
        // IE以外の場合
        navigator.clipboard
          .writeText(urlText.value)
          .then(function () {
            alert('コピーしました。');
          })
          .catch(function () {
            alert('ご利用の環境ではクリップボードに保存できません。テキストを選択してコピーしてください。');
          });
      } else {
        alert('ご利用の環境ではクリップボードに保存できません。テキストを選択してコピーしてください。');
      }
    });
    copyUrl.appendChild(template_copy_url_elm);

    shareURL.insertBefore(copyUrl, displayButton);
  },

  componentDidMount: function () {
    // 画像のアスペクト比を維持する
    if (this.AnswerTr) {
      setAspectRatioToImg(this.AnswerTr);
    }
    if (this.AnswerTr2) {
      setAspectRatioToImg(this.AnswerTr2);
    }
  },

  render: function () {
    let result = this.props.result;
    let question = this.props.question;
    let gotoQACandidatePanel = this.props.gotoQACandidatePanel;
    let askQuestion = this.props.askQuestion;
    let generateAlert = this.props.generateAlert;

    let answerLines = newlineToBr('');
    let answerLines2 = newlineToBr('');

    let resultAnswer = result.answer ? result.answer : '';

    if (result.brief_answer) {
      answerLines = newlineToBr(result.brief_answer + '\n', 'brief_answer');
      answerLines2 = newlineToBr(resultAnswer, 'answer');
    } else if (result.answer) {
      answerLines = newlineToBr(resultAnswer, 'answer');
    }

    let datetime = '';
    if (result.datetime_modified) {
      datetime = result.datetime_modified.slice(0, 10);
    }

    const shareUrlBtnStyle = {
      backgroundImage: 'url(' + DESIGN.SHARE_BUTTON_PATH + ')'
    };
    let shareURL_button = (
      <button
        style={shareUrlBtnStyle}
        className="button_share"
        onClick={this.displayShareButton}
        type="button"
      ></button>
    );

    let enableShareButton = CONFIG.ENABLE_SHARE_BUTTON;

    let logId = this.props.logId;
    let qaId = result.id;
    let qa_question = result.question;
    let qa_answer = result.answer;
    let qa_category = result.category;
    myAjax(
      '/api/logging/core/' + logId,
      {
        selected_qa: qaId,
        selected_qa_question: qa_question,
        selected_qa_answer: qa_answer,
        selected_qa_category_text: qa_category,
        user_rating: 0,
        negative_rating_reason: RATING_REASON_INITIAL_LABEL,
        negative_rating_reason_free: ''
      },
      'PATCH'
    );

    return (
      <div>
        <table
          className="table"
          style={{
            fontSize: 'medium',
            wordBreak: 'break-all',
            marginTop: '10px'
          }}
        >
          <tbody>
            <AnswerPanelTableIsCorrectTr
              result={result}
              question={question}
              logId={this.props.logId}
              cgId={this.props.cgId}
              gotoQACandidatePanel={gotoQACandidatePanel}
              askQuestion={askQuestion}
              generateAlert={generateAlert}
            />

            <AnswerPanelTableQuestionsTr result={result} />

            <tr ref={(node) => (this.AnswerTr = node)}>
              <td style={{paddingTop: '15px', paddingBottom: '0px'}}>A:</td>
              <td
                style={{
                  paddingTop: '15px',
                  paddingBottom: '0px',
                  width: '150px'
                }}
              >
                {DESIGN.DEFAULT}
              </td>
              <td colSpan="2" style={{verticalAlign: 'middle'}}>
                <span dangerouslySetInnerHTML={answerLines} />
                <br />
              </td>
            </tr>
            <tr ref={(node) => (this.AnswerTr2 = node)}>
              <td></td>
              <td colSpan="2">
                <span dangerouslySetInnerHTML={answerLines2}></span>
              </td>
            </tr>
            {enableShareButton && (
              <tr>
                <td colSpan="4" className="text-end">
                  <div className="share_URL" id="share_URL">
                    {enableShareButton && <span id="display_button">{shareURL_button}</span>}
                  </div>
                </td>
              </tr>
            )}
            <tr>
              <td colSpan="4" className="text-end">
                <span className="text-left text-muted pull-right" style={{fontSize: 'small'}}>
                  回答最終更新日 {datetime}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
});

export default AnswerPanelTable;
